import { render } from "./EditBtnComp.vue?vue&type=template&id=3ea65947"
import script from "./EditBtnComp.vue?vue&type=script&lang=js"
export * from "./EditBtnComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__